import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

interface Props {
  element: DocumentElementType;
}

/**
 * A horizontal divider. A non-text block: it has no editable content, so the
 * editor host handles Enter (via the block wrapper) to add a text block after
 * it. Purely presentational.
 */
const PageDivider: React.FC<Props> = () => {
  return (
    <div className="py-[6px]">
      <hr className="border-0 border-t border-[#ebeae7]" />
    </div>
  );
};

export default PageDivider;
